/* ZYNEX - tema özelleştirmeleri
   Joykek 2026-09-07. Wokiee'nin kendi dosyalarına dokunulmaz.

   Ürün galerisi: ızgarada en fazla 6 görsel gösterilir.
   6. görselin üstüne "+N" katmanı basılır; tıklanınca kalanlar açılır.
*/
(function () {
  'use strict';

  var SINIR = 6;

  /* Renk secimi degisince Wokiee eslesmeyen gorsellere `.hide` ekliyor.
     Bu yuzden sinir `nth-child` ile kurulamaz - her seferinde GORUNUR
     ogeler sayilip fazlasi `.zx-fazla` ile gizleniyor. */
  function gorunurOgeler(izgara) {
    return Array.prototype.filter.call(izgara.children, function (e) {
      return e.classList &&
             e.classList.contains('product-media__item') &&
             !e.classList.contains('hide');
    });
  }

  function katmanYap(kalan) {
    var d = document.createElement('button');
    d.type = 'button';
    d.className = 'zx-galeri-daha';
    d.setAttribute('aria-label', kalan + ' görsel daha göster');
    d.innerHTML = '<span class="zx-galeri-daha__sayi">+' + kalan + '</span>' +
                  '<span class="zx-galeri-daha__metin">TÜMÜNÜ GÖR</span>';
    return d;
  }

  function uygula(izgara) {
    if (izgara.dataset.zxAcik === '1') return;          // kullanici actiysa dokunma
    var eski = izgara.querySelector('.zx-galeri-daha');
    if (eski) eski.remove();
    Array.prototype.forEach.call(izgara.children, function (e) {
      if (e.classList) { e.classList.remove('zx-fazla'); e.classList.remove('zx-tetik'); }
    });

    var ogeler = gorunurOgeler(izgara);
    if (ogeler.length <= SINIR) return;

    for (var i = SINIR; i < ogeler.length; i++) ogeler[i].classList.add('zx-fazla');

    var tetik = ogeler[SINIR - 1];
    tetik.classList.add('zx-tetik');
    if (getComputedStyle(tetik).position === 'static') tetik.style.position = 'relative';
    var katman = katmanYap(ogeler.length - SINIR);
    tetik.appendChild(katman);
    katman.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      izgara.dataset.zxAcik = '1';
      Array.prototype.forEach.call(izgara.children, function (x) {
        if (x.classList) { x.classList.remove('zx-fazla'); x.classList.remove('zx-tetik'); }
      });
      katman.remove();
    });
  }

  var zamanlayici = null;
  function tara() {
    document.querySelectorAll('.media-design__columns_2').forEach(function (izgara) {
      uygula(izgara);
      if (izgara.dataset.zxIzleniyor === '1') return;
      izgara.dataset.zxIzleniyor = '1';
      // renk degisince `.hide` siniflari degisiyor - yeniden hesapla
      new MutationObserver(function () {
        clearTimeout(zamanlayici);
        zamanlayici = setTimeout(function () {
          izgara.dataset.zxAcik = '';                   // renk degisti, sinir geri gelsin
          uygula(izgara);
        }, 60);
      }).observe(izgara, { attributes: true, attributeFilter: ['class'], subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tara);
  } else { tara(); }
  window.addEventListener('load', function () { setTimeout(tara, 400); });
})();

/* ------------------------------------------------------------------
   Ürün karusellerinin altında kaydırma çizgisi (dossha: sgf-progress-bar)
   iz 400x4 rgba(17,17,17,.15) · tutamak koyu, orana göre genişler/kayar
------------------------------------------------------------------ */
(function () {
  'use strict';

  var IZ_GENISLIK = 400;

  function ilerlemeKur(swiper) {
    if (!swiper || swiper.dataset.zxIlerleme === 'kuruldu') return;
    var sarmal = swiper.querySelector('.swiper-wrapper');
    if (!sarmal) return;
    if (sarmal.scrollWidth <= swiper.clientWidth + 8) return; // kaydırma yoksa çizgi yok

    swiper.dataset.zxIlerleme = 'kuruldu';

    var iz = document.createElement('div');
    iz.className = 'zx-kaydirma-iz';
    var tutamak = document.createElement('span');
    tutamak.className = 'zx-kaydirma-tutamak';
    iz.appendChild(tutamak);
    swiper.parentElement.insertBefore(iz, swiper.nextSibling);

    function guncelle() {
      var toplam = sarmal.scrollWidth;
      var gorunen = swiper.clientWidth;
      if (toplam <= gorunen) { iz.style.display = 'none'; return; }
      iz.style.display = '';

      var m = getComputedStyle(sarmal).transform;
      var x = 0;
      if (m && m !== 'none') {
        var p = m.match(/matrix.*\((.+)\)/);
        if (p) {
          var d = p[1].split(', ');
          x = parseFloat(d.length > 6 ? d[12] : d[4]) || 0;
        }
      }
      var ilerleme = Math.min(1, Math.max(0, -x / (toplam - gorunen)));
      var oran = Math.max(0.12, gorunen / toplam);
      var tw = IZ_GENISLIK * oran;
      tutamak.style.width = tw + 'px';
      tutamak.style.transform = 'translateX(' + (ilerleme * (IZ_GENISLIK - tw)) + 'px)';
    }

    guncelle();
    new MutationObserver(guncelle).observe(sarmal, { attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', guncelle);
  }

  function tara() {
    // dossha yalnızca ÜRÜN KARUSELLERİNİN altında bu çizgiyi gösteriyor.
    // Kategori daireleri, renk şeritleri, shop-the-look ve hero slider hariç.
    document.querySelectorAll('[id*="featured_"]').forEach(function (sec) {
      // her ürün KARTININ içinde de bir swiper var (kart galerisi) - onlara çizgi eklenmez.
      // Bölümün DIŞ karuseli aranır.
      var hepsi = sec.querySelectorAll('.swiper');
      for (var i = 0; i < hepsi.length; i++) {
        var sw = hepsi[i];
        if (sw.closest('.product-card')) continue;
        if (sw.closest('[id*="slider_"]')) continue;
        ilerlemeKur(sw);
        break; // bölüm başına tek çizgi
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(tara, 600); });
  } else {
    setTimeout(tara, 600);
  }
  window.addEventListener('load', function () { setTimeout(tara, 400); });
})();

/* ------------------------------------------------------------------
   Kaydirma durumu isareti
   Ana sayfada header slaytin uzerine biniyor ve tepede seffaf duruyor.
   Wokiee'nin kendi `sticky-activated` isareti, header'i akistan cikardigimiz
   icin artik uretilmiyor - durumu kendimiz isaretliyoruz.
------------------------------------------------------------------ */
(function () {
  'use strict';
  var kok = document.documentElement;
  function guncelle() {
    kok.classList.toggle('zx-kaydirildi', (window.scrollY || window.pageYOffset) > 40);
  }
  guncelle();
  window.addEventListener('scroll', guncelle, { passive: true });
  window.addEventListener('resize', guncelle, { passive: true });
})();

/* ------------------------------------------------------------------
   Renk koleksiyonunda kartlar O RENGIN gorselini gostersin
   Kart galerisini "gallery" moduna almak sayfayi cokertiyordu (urun basina
   30-40 medya). Onun yerine sayfa basina TEK istekle koleksiyonun urun
   JSON'u cekilip her kartin ana gorseli o rengin varyant gorseliyle
   degistiriliyor.
------------------------------------------------------------------ */
(function () {
  'use strict';

  var HARITA = {
    'siyah': 'siyah', 'kemik': 'kemik', 'aci-kahve': 'acı kahve',
    'gardenya': 'gardenya (mürdüm)', 'yag-yesili': 'yağ yeşili',
    'pembe': 'pembe', 'sari': 'sarı'
  };

  var m = location.pathname.match(/\/collections\/([^\/?#]+)/);
  if (!m) return;
  var handle = m[1];
  var renk = HARITA[handle];
  if (!renk) return;

  fetch('/collections/' + handle + '/products.json?limit=250')
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (d) {
      if (!d || !d.products) return;
      var esle = {};
      d.products.forEach(function (u) {
        for (var i = 0; i < u.variants.length; i++) {
          var v = u.variants[i];
          var o = (v.option1 || '').toLowerCase();
          if (o === renk && v.featured_image && v.featured_image.src) {
            esle[u.handle] = v.featured_image.src; break;
          }
        }
      });
      uygula(esle);
      new MutationObserver(function () { uygula(esle); })
        .observe(document.body, { childList: true, subtree: true });
    })
    .catch(function () {});

  function uygula(esle) {
    document.querySelectorAll('.product-card').forEach(function (kart) {
      if (kart.dataset.zxRenkli === '1') return;
      var bag = kart.querySelector('a[href*="/products/"]');
      if (!bag) return;
      var h = (bag.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0];
      var src = esle[h];
      if (!src) return;
      var im = kart.querySelector('.product-card__image img') || kart.querySelector('img');
      if (!im) return;
      var temiz = src.split('?')[0];
      im.setAttribute('src', temiz + '?width=600');
      im.setAttribute('srcset', temiz + '?width=400 400w, ' + temiz + '?width=600 600w, ' + temiz + '?width=900 900w');
      im.removeAttribute('data-srcset');
      kart.dataset.zxRenkli = '1';
    });
  }
})();

/* ------------------------------------------------------------------
   Ürün sayfası altı: "Beğenebilecekleriniz" / "Son Görüntülenenler" sekmesi
   Iki ayri bolum tek sekme cubugu altinda toplanir. Son Goruntulenenler
   kullaniciya ozeldir; veri yoksa magazadan rastgele urun gosterilir.
------------------------------------------------------------------ */
(function () {
  'use strict';

  function bolum(parca) {
    return document.querySelector('.shopify-section[id*="' + parca + '"]');
  }

  function kartSay(s) { return s ? s.querySelectorAll('.product-card').length : 0; }

  function basligiAl(s) {
    var h = s.querySelector('h2, .h2, [class*="section__heading"]');
    return h ? h.textContent.trim() : '';
  }

  function kur() {
    var a = bolum('begenebilecekleriniz');
    var b = bolum('son_goruntulenenler');
    if (!a || !b || a.dataset.zxSekme === '1') return;
    a.dataset.zxSekme = '1';

    var adlar = [basligiAl(a) || 'Beğenebilecekleriniz', basligiAl(b) || 'Son Görüntülenenler'];
    a.classList.add('zx-sekme-govde');
    b.classList.add('zx-sekme-govde');

    var cubuk = document.createElement('div');
    cubuk.className = 'zx-sekmeler';
    [a, b].forEach(function (s, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'zx-sekme' + (i === 0 ? ' aktif' : '');
      d.textContent = adlar[i];
      d.addEventListener('click', function () {
        cubuk.querySelectorAll('.zx-sekme').forEach(function (x) { x.classList.remove('aktif'); });
        d.classList.add('aktif');
        a.classList.toggle('zx-gizli', i !== 0);
        b.classList.toggle('zx-gizli', i !== 1);
      });
      cubuk.appendChild(d);
    });
    a.parentNode.insertBefore(cubuk, a);
    b.classList.add('zx-gizli');
  }

  /* Gercek urun karti sayisi: yer tutucu kartlarda urun baglantisi yoktur.
     Shopify'in oneri servisi bu magazada henuz veri dondurmuyor ve tema
     "Product name / €19,95" yer tutucularini basiyor. */
  function gercekKart(s) {
    return s ? s.querySelectorAll('.product-card a[href*="/products/"]').length : 0;
  }

  /* Bos VEYA yer tutucu dolu bolumu magazadan rastgele urunle doldurur.
     Kartlar sade tutuluyor (gorsel + ad + fiyat + baglanti); tema kartinin
     sepet formunu klonlamak yanlis varyant kimligi tasirdi. */
  function rastgeleDoldur(parca) {
    var b = bolum(parca || 'son_goruntulenenler');
    if (!b || b.dataset.zxRastgele === '1') return;
    if (gercekKart(b) > 0) return;                 // gercek urun varsa dokunma
    b.dataset.zxRastgele = '1';
    /* Yer tutucu kaplarini tek tek gizlemek yeterli olmadi (kartlar sonradan
       basiliyor). Bolume sinif veriliyor, gizleme CSS'te - sonradan gelen
       kartlar da kapsaniyor. */
    b.classList.add('zx-yer-tutucu');
    fetch('/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.products || !d.products.length) return;
        var buH = (location.pathname.split('/products/')[1] || '').split('?')[0].split('#')[0];
        var havuz = d.products.filter(function (u) {
          return u.images && u.images.length && u.handle !== buH;
        });
        for (var i = havuz.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = havuz[i]; havuz[i] = havuz[j]; havuz[j] = t;
        }
        var sec = havuz.slice(0, 4);
        /* Izgara BOLUMUN kendisine ekleniyor. Tema kabinin icine konunca
           `.zx-yer-tutucu` gizlemesinin altinda kaliyor ve gorseller hic
           yuklenmiyordu (naturalWidth 0). */
        var kap = b;
        var izgara = document.createElement('div');
        izgara.className = 'zx-rastgele-izgara';
        sec.forEach(function (u) {
          var src = u.images[0].src.split('?')[0];
          var fiyat = u.variants && u.variants[0] ? u.variants[0].price : '';
          var a = document.createElement('a');
          a.className = 'zx-rastgele-kart';
          a.href = '/products/' + u.handle;
          a.innerHTML =
            '<span class="zx-rastgele-gorsel"><img loading="lazy" src="' + src + '?width=600" alt=""></span>' +
            '<span class="zx-rastgele-ad">' + u.title + '</span>' +
            (fiyat ? '<span class="zx-rastgele-fiyat">' + fiyat + ' TL</span>' : '');
          izgara.appendChild(a);
        });
        kap.appendChild(izgara);
      })
      .catch(function () {});
  }

  function calistir() { kur(); rastgeleDoldur('begenebilecekleriniz'); rastgeleDoldur('son_goruntulenenler'); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', calistir);
  } else { calistir(); }
  window.addEventListener('load', function () { setTimeout(calistir, 700); });
})();

/* ------------------------------------------------------------------
   Ürün kartı - dossha davranisi
   · "Sepete ekle" gizlenir
   · Beden secimi GORSELIN uzerine katman olarak tasinir, hover'da acilir
   · Beden veya renk tiklaninca ilgili varyantla URUN SAYFASINA gidilir
------------------------------------------------------------------ */
(function () {
  'use strict';

  function varyantlar(kart) {
    var s = kart.querySelector('card-variant-selects script');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function urunYolu(kart) {
    var a = kart.querySelector('a[href*="/products/"]');
    return a ? a.getAttribute('href').split('?')[0] : null;
  }

  function git(kart, renk, beden) {
    var yol = urunYolu(kart);
    if (!yol) return;
    var vs = varyantlar(kart), id = null;
    if (vs) {
      for (var i = 0; i < vs.length; i++) {
        var v = vs[i];
        var o1 = (v.option1 || '').toLowerCase();
        var o2 = (v.option2 || '').toLowerCase();
        if (renk && beden) { if (o1 === renk && o2 === beden) { id = v.id; break; } }
        else if (renk)     { if (o1 === renk) { id = v.id; break; } }
        else if (beden)    { if (o2 === beden) { id = v.id; break; } }
      }
    }
    location.href = yol + (id ? '?variant=' + id : '');
  }

  function seciliRenk(kart) {
    var r = kart.querySelector('input[name="Renk"]:checked, input[type=radio]:checked');
    return r ? (r.value || '').toLowerCase() : null;
  }

  function kur(kart) {
    if (kart.dataset.zxKart === '1') return;
    kart.dataset.zxKart = '1';

    var secici = kart.querySelector('card-variant-selects');
    var gorsel = kart.querySelector('.product-card__image__container');
    if (!secici || !gorsel) return;

    var alanlar = secici.querySelectorAll('fieldset.product-form__input');
    var bedenAlan = null;
    for (var i = 0; i < alanlar.length; i++) {
      if (alanlar[i].querySelector('.btn--variant-smallcard')) { bedenAlan = alanlar[i]; break; }
    }
    if (bedenAlan) {
      var katman = document.createElement('div');
      katman.className = 'zx-beden-katman';
      var etiket = document.createElement('span');
      etiket.className = 'zx-beden-etiket';
      etiket.textContent = 'Beden Seç:';
      katman.appendChild(etiket);
      katman.appendChild(bedenAlan);
      gorsel.appendChild(katman);

      katman.addEventListener('click', function (e) {
        var l = e.target.closest('label.btn--variant-smallcard');
        if (!l) return;
        e.preventDefault(); e.stopPropagation();
        var t = (l.textContent || '').trim().split('\n')[0].trim().toLowerCase();
        git(kart, seciliRenk(kart), t);
      }, true);
    }

    // renk secimi -> urun sayfasi (o renk secili)
    secici.addEventListener('click', function (e) {
      var l = e.target.closest('label.color__swatch');
      if (!l) return;
      e.preventDefault(); e.stopPropagation();
      var kutu = l.closest('.product-form__item');
      var inp = kutu ? kutu.querySelector('input') : null;
      git(kart, inp ? (inp.value || '').toLowerCase() : null, null);
    }, true);
  }

  function tara() { document.querySelectorAll('.product-card').forEach(kur); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tara);
  } else { tara(); }
  window.addEventListener('load', function () { setTimeout(tara, 500); });
  new MutationObserver(function () { tara(); })
    .observe(document.body, { childList: true, subtree: true });
})();

/* ------------------------------------------------------------------
   Ürün sayfası: "KOMBİNİ TAMAMLA" - ayni renkteki diger urunler
   Shopify'in "complementary" ozelligi Search & Discovery'ye bagli ve zaten
   algoritmik; istenen RENK bazli oldugu icin kendi seridimizi kuruyoruz.
   Renk degisince serit yeniden yukleniyor.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  var ADET = 4;                     // tek satirda gosterilecek urun sayisi
  var HANDLE = {
    'siyah': 'siyah', 'kemik': 'kemik', 'acı kahve': 'aci-kahve',
    'gardenya (mürdüm)': 'gardenya', 'yağ yeşili': 'yag-yesili',
    'pembe': 'pembe', 'sarı': 'sari'
  };
  var buUrun = (location.pathname.split('/products/')[1] || '').split('?')[0].split('#')[0];
  var kutu = null, sonRenk = null;

  function seciliRenk() {
    var r = document.querySelector('input[name="Renk"]:checked');
    if (r) return (r.value || '').toLowerCase();
    var s = document.querySelector('[data-main-color]');
    return s ? (s.getAttribute('data-main-color') || '').toLowerCase() : null;
  }

  function kutuYap() {
    if (kutu) return kutu;
    var dugme = document.querySelector('.product-form__submit, button[name="add"]');
    if (!dugme) return null;
    /* Buton satiri `nowrap` esnek kutu - serit onun ICINE girerse yan yana
       diziliyor. Blok seviyesindeki `.product-form__buttons` sarmalinin
       ARDINA konuyor. */
    var yer = dugme.closest('.product-form__buttons') ||
              dugme.closest('.product__block') ||
              dugme.parentElement;
    kutu = document.createElement('div');
    kutu.className = 'zx-kombin';
    kutu.innerHTML = '<div class="zx-kombin__baslik">KOMBİNİ TAMAMLA</div><div class="zx-kombin__sira"></div>';
    yer.parentNode.insertBefore(kutu, yer.nextSibling);
    return kutu;
  }

  function doldur(renk) {
    var h = HANDLE[renk];
    if (!h) return;
    var k = kutuYap();
    if (!k) return;
    var sira = k.querySelector('.zx-kombin__sira');
    sira.setAttribute('aria-busy', 'true');
    fetch('/collections/' + h + '/products.json?limit=250')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        sira.removeAttribute('aria-busy');
        if (!d || !d.products) { k.style.display = 'none'; return; }
        var liste = d.products.filter(function (u) { return u.handle !== buUrun && u.images && u.images.length; });
        for (var i = liste.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var t = liste[i]; liste[i] = liste[j]; liste[j] = t;
        }
        liste = liste.slice(0, ADET);   // tek satir: sutun sayisiyla ayni
        if (!liste.length) { k.style.display = 'none'; return; }
        k.style.display = '';
        sira.innerHTML = '';
        liste.forEach(function (u) {
          // o rengin varyant gorseli varsa onu kullan
          var src = u.images[0].src;
          for (var i = 0; i < u.variants.length; i++) {
            var v = u.variants[i];
            if ((v.option1 || '').toLowerCase() === renk && v.featured_image && v.featured_image.src) {
              src = v.featured_image.src; break;
            }
          }
          src = src.split('?')[0];
          var f = u.variants && u.variants[0] ? u.variants[0].price : '';
          var a = document.createElement('a');
          a.className = 'zx-kombin__kart';
          a.href = '/products/' + u.handle;
          a.innerHTML = '<span class="zx-kombin__gorsel"><img loading="lazy" src="' + src + '?width=300" alt=""></span>' +
                        '<span class="zx-kombin__ad">' + u.title + '</span>' +
                        (f ? '<span class="zx-kombin__fiyat">' + f + ' TL</span>' : '');
          sira.appendChild(a);
        });
      })
      .catch(function () { sira.removeAttribute('aria-busy'); });
  }

  function guncelle() {
    var r = seciliRenk();
    if (!r || r === sonRenk) return;
    sonRenk = r;
    doldur(r);
  }

  function baslat() {
    guncelle();
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'Renk') setTimeout(guncelle, 60);
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.color__swatch')) setTimeout(guncelle, 180);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else { baslat(); }
  window.addEventListener('load', function () { setTimeout(guncelle, 800); });
})();

/* ------------------------------------------------------------------
   Lookbook noktalari: gorselin sag yarisindakiler karti SAGA,
   sol yarisindakiler SOLA acar (ekran disina tasmasin)
------------------------------------------------------------------ */
(function () {
  'use strict';
  function yon() {
    var s = document.querySelector('.shopify-section[id*="hero_banner"]');
    if (!s) return;
    var gorsel = s.querySelector('img');
    if (!gorsel) return;
    var kutu = gorsel.getBoundingClientRect();
    if (!kutu.width) return;
    s.querySelectorAll('lookbook-bullet').forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (!r.width) return;
      var oran = (r.left + r.width / 2 - kutu.left) / kutu.width;
      n.classList.remove('zx-saga', 'zx-sola');
      n.classList.add(oran > 0.5 ? 'zx-saga' : 'zx-sola');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(yon, 600); });
  } else { setTimeout(yon, 600); }
  window.addEventListener('load', function () { setTimeout(yon, 500); });
  window.addEventListener('resize', function () { setTimeout(yon, 200); });
})();

/* ------------------------------------------------------------------
   Galeri renk filtresi - ACILIS
   Wokiee'nin `initMedia()` fonksiyonu `select-option-js.active` varsa
   atliyor; bizim varyant secicimizde bu kosul olustugu icin sayfa
   acildiginda HICBIR gorsel `.hide` almiyor ve tum renkler yan yana
   duruyordu. Secili rengi okuyup filtreyi kendimiz uyguluyoruz.
   Renk degisiminde temanin `updateMedia()` zaten devrede.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  function aktifRenk() {
    var r = document.querySelector('input[name="Renk"]:checked');
    if (r && r.value) return r.value.trim().toLowerCase();
    var m = document.querySelector('[data-main-color]');
    var v = m ? (m.getAttribute('data-main-color') || '').trim().toLowerCase() : '';
    return v.length > 1 ? v : null;      // "s" gibi bozuk degerleri ele
  }

  function filtrele() {
    var renk = aktifRenk();
    if (!renk) return false;
    var ogeler = document.querySelectorAll('[data-current-color]');
    if (!ogeler.length) return false;
    var eslesen = 0;
    ogeler.forEach(function (e) {
      var v = (e.getAttribute('data-current-color') || '').trim().toLowerCase();
      if (v === renk) { e.classList.remove('hide'); eslesen++; }
      else { e.classList.add('hide'); }
    });
    return eslesen > 0;
  }

  function dene(kalan) {
    if (filtrele()) return;
    if (kalan > 0) setTimeout(function () { dene(kalan - 1); }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { dene(6); });
  } else { dene(6); }
  window.addEventListener('load', function () { setTimeout(function () { dene(3); }, 300); });
})();

/* ------------------------------------------------------------------
   Ürün sayfası SABİT ŞERİT - dossha davranışı
   Wokiee'nin `sticky-cart-modal` ogesi ekranin ALTINDA duruyor ve icinde
   yalnizca buton var. dossha'da serit header'in ALTINDA sabit durur ve
   kucuk gorsel + ad + fiyat + renk/beden tasir.
   Olculen dossha degerleri: yukseklik 81px · beyaz · alt cizgi 1px #EBEBEB
   · gorsel 40x40 · ad 14px/700 · fiyat 14px · varyant 14px %70 opaklik
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (!/\/products\//.test(location.pathname)) return;

  var serit, bilgi;

  function metin(sec) {
    var e = document.querySelector(sec);
    return e ? e.textContent.trim().replace(/\s+/g, ' ') : '';
  }

  function aktifGorsel() {
    var g = document.querySelector('.media-design__columns_2 .product-media__item:not(.hide) img')
         || document.querySelector('.product__media img');
    return g ? (g.currentSrc || g.src) : '';
  }

  /* Tema secili degeri radio `checked` ile DEGIL, legend metniyle veriyor:
     "Renk: Siyah" / "Beden: XS" */
  function varyantMetni() {
    var p = [];
    document.querySelectorAll('legend, .product-form__input .form__label').forEach(function (e) {
      var t = (e.textContent || '').trim().replace(/\s+/g, ' ');
      var i = t.indexOf(':');
      if (i > 0 && i < t.length - 1) {
        var d = t.slice(i + 1).trim();
        if (d && p.indexOf(d) === -1) p.push(d);
      }
    });
    return p.slice(0, 2);
  }

  function kur() {
    serit = document.querySelector('sticky-cart-modal');
    if (!serit || serit.dataset.zxSerit === '1') return;
    serit.dataset.zxSerit = '1';
    bilgi = document.createElement('div');
    bilgi.className = 'zx-serit-bilgi';
    serit.insertBefore(bilgi, serit.firstChild);
    guncelle();
  }

  function guncelle() {
    if (!bilgi) return;
    var src = aktifGorsel();
    var ad = metin('h1');
    var fiyat = metin('.price__main, .price .price__container, [class*="price__main"]');
    var v = varyantMetni();
    bilgi.innerHTML =
      (src ? '<span class="zx-serit-gorsel"><img src="' + src.split('?')[0] + '?width=120" alt=""></span>' : '') +
      '<span class="zx-serit-metin">' +
        '<span class="zx-serit-ad">' + ad + '</span>' +
        '<span class="zx-serit-alt">' +
          (fiyat ? '<span class="zx-serit-fiyat">' + fiyat + '</span>' : '') +
          v.map(function (x) { return '<span class="zx-serit-varyant">' + x + '</span>'; }).join('') +
        '</span>' +
      '</span>';
  }

  /* Yapiskan header'in yuksekligi: serit tam onun altina oturur.
     Deger CSS'e --zx-serit-top ile gecer (CSS'te !important oldugu icin
     inline style ile ezilemez). */
  function headerYuksekligi() {
    var h = document.querySelector('.shopify-section-group-header-group.section-header');
    if (!h) return 68;
    var y = Math.round(h.getBoundingClientRect().height);
    return y > 20 ? y : 68;
  }

  /* Galerinin ALT kenari: masaustunde 2 kolonlu izgara, mobilde swiper.
     Tek olcut ikisini de kapsasin diye GORUNUR medya ogelerinin en alt
     kenari aliniyor (masaustu izgara kutusu mobilde 0 yukseklikte kalir). */
  function galeriAlt() {
    var alt = null;
    document.querySelectorAll('.product-media__item').forEach(function (o) {
      var r = o.getBoundingClientRect();
      if (r.height > 0 && (alt === null || r.bottom > alt)) alt = r.bottom;
    });
    if (alt !== null) return alt;
    var izgara = document.querySelector('.media-design__columns_2');
    return izgara ? izgara.getBoundingClientRect().bottom : null;
  }

  /* Tetik: urun gorselleri ekrandan cikinca serit acilir.
     Urun kolonu YAPISKAN oldugu icin satin alma butonu hic ekrandan cikmiyor;
     olcut galerinin ALT kenarinin yapiskan header'in altina gecmesi. */
  function gorunurluk() {
    if (!serit) return;
    var ust = headerYuksekligi();
    document.documentElement.style.setProperty('--zx-serit-top', ust + 'px');
    var alt = galeriAlt();
    var acik = (alt === null)
      ? (window.scrollY || window.pageYOffset) > 600
      : alt <= ust;
    serit.classList.toggle('zx-serit-acik', acik);
  }

  function baslat() {
    kur(); gorunurluk();
    window.addEventListener('scroll', gorunurluk, { passive: true });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.type === 'radio') setTimeout(guncelle, 120);
    });
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.color__swatch, .btn--variant-smallcard'))
        setTimeout(guncelle, 250);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', baslat);
  } else { baslat(); }
  window.addEventListener('load', function () { setTimeout(baslat, 600); });
})();

/* ============================================================
   ANASAYFA HERO VIDEOLARI
   Shopify bu magazada VIDEO tipini transcode edemedi (yuklenen
   dosyalar FAILED olup siliniyor). Cozum: videolar GENEL DOSYA
   olarak yuklendi (READY + dogrudan CDN adresi) ve slaytlara
   burada gomuluyor. Poster olarak mevcut slayt gorseli kaliyor.
   ============================================================ */
(function () {
  var VIDEOLAR = [
    'https://cdn.shopify.com/s/files/1/0853/2223/6116/files/zynex-hero-01.mp4?v=1789486716',
    'https://cdn.shopify.com/s/files/1/0853/2223/6116/files/zynex-hero-02.mp4?v=1789486716',
    'https://cdn.shopify.com/s/files/1/0853/2223/6116/files/zynex-hero-03.mp4?v=1789486715',
    'https://cdn.shopify.com/s/files/1/0853/2223/6116/files/zynex-hero-04.mp4?v=1789486716'
  ];
  var gozcu = null;
  function kur() {
    var bolum = document.querySelector('.shopify-section[id*="slider_"]');
    if (!bolum) return;
    var slaytlar = bolum.querySelectorAll('.swiper-slide');
    if (!slaytlar.length) return;
    if (gozcu) gozcu.disconnect();
    slaytlar.forEach(function (s, sira) {
      /* swiper indeksi ilk boyamada henuz yazilmamis olabilir; o an DOM sirasi kullanilir
         ve indeks sonradan gelince video kaynagi guncellenir */
      var ham = s.getAttribute('data-swiper-slide-index');
      var i = (ham === null || ham === '') ? sira : parseInt(ham, 10);
      var adres = VIDEOLAR[i % VIDEOLAR.length];
      var v = s.querySelector('.zx-hero-video');
      if (v) {
        if (v.getAttribute('data-zx-slayt') !== String(i)) {
          v.setAttribute('data-zx-slayt', String(i));
          v.src = adres;
          var y = v.play();
          if (y && y.catch) y.catch(function () {});
        }
        return;
      }
      /* gorsel kutusu orani belirliyor; video onun UZERINE biniyor */
      var kutu = s.querySelector('.image-hover-box') || s.querySelector('.bg-preloader');
      if (!kutu) return;
      v = document.createElement('video');
      v.className = 'zx-hero-video';
      v.setAttribute('data-zx-slayt', String(i));
      v.muted = true; v.defaultMuted = true; v.loop = false; v.autoplay = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', '');
      v.setAttribute('autoplay', '');
      v.preload = 'auto';
      v.src = adres;
      kutu.appendChild(v);
      var oynat = v.play();
      if (oynat && oynat.catch) oynat.catch(function () { /* otomatik oynatma engellendi */ });
    });
    if (gozcu && bolum) gozcu.observe(bolum, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur);
  else kur();
  /* swiper klon slaytlari sonradan uretiyor */
  gozcu = new MutationObserver(function () { kur(); });
  var hedef = document.querySelector('.shopify-section[id*="slider_"]');
  if (hedef) gozcu.observe(hedef, { childList: true, subtree: true });
  setTimeout(kur, 800); setTimeout(kur, 1800); setTimeout(kur, 3500);
})();


/* ============================================================
   SLAYT GECISI VIDEOYA BAGLI (Tur 54)
   Tema 6 sn sabit otomatik gecis kullaniyordu; videolar 3.9-7.9 sn
   arasi oldugu icin bazi videolar yarida kesiliyordu. Otomatik gecis
   kapatilip slayt, aktif videonun bitisine ~0.35 sn kala ilerletiliyor.
   ============================================================ */
(function () {
  var BOSLUK = 350;     /* video bitisine kala gecis payi (ms) */
  var YEDEK  = 6000;    /* video yoksa eski davranis */
  function slider() {
    var k = document.querySelector('.shopify-section[id*="slider_"] .swiper');
    return (k && k.swiper) ? k.swiper : null;
  }
  function kur() {
    var sw = slider();
    if (!sw || sw.zxVideoBagli) return !!sw;
    sw.zxVideoBagli = true;
    if (sw.autoplay && sw.autoplay.stop) { sw.autoplay.stop(); }
    if (sw.params) { sw.params.autoplay = false; }
    var sayac = null;

    function aktifSlayt() {
      return sw.slides ? (sw.slides[sw.activeIndex] || null) : null;
    }
    function ilerle() {
      clearTimeout(sayac); sayac = null;
      if (sw.slideNext) sw.slideNext();
    }
    function kur_sayac(ms) {
      clearTimeout(sayac);
      sayac = setTimeout(ilerle, Math.max(1200, ms));
    }
    function baslat() {
      clearTimeout(sayac);
      /* aktif olmayan videolari durdur */
      document.querySelectorAll('.zx-hero-video').forEach(function (v) {
        var s = v.closest('.swiper-slide');
        if (s !== aktifSlayt()) { try { v.pause(); } catch (e) {} }
      });
      var sl = aktifSlayt();
      var v = sl ? sl.querySelector('.zx-hero-video') : null;
      if (!v) { kur_sayac(YEDEK); return; }
      v.loop = false; v.removeAttribute('loop');
      try { v.currentTime = 0; } catch (e) {}
      var oynat = v.play();
      if (oynat && oynat.catch) oynat.catch(function () { kur_sayac(YEDEK); });
      v.onended = function () { ilerle(); };
      function olc() {
        var d = v.duration;
        if (d && isFinite(d) && d > 0) kur_sayac(d * 1000 - BOSLUK);
        else kur_sayac(YEDEK);
      }
      if (v.readyState >= 1) olc();
      else v.addEventListener('loadedmetadata', olc, { once: true });
    }
    sw.on('slideChangeTransitionEnd', baslat);
    /* kullanici elle gecerse sayaci sifirla */
    sw.on('touchEnd', function () { setTimeout(baslat, 60); });
    baslat();
    return true;
  }
  var deneme = 0;
  var i = setInterval(function () {
    if (kur() || ++deneme > 40) clearInterval(i);
  }, 400);
})();


/* ============================================================
   TUR 55 - MOBIL DOSSHA ESITLEME (JS tarafi)
   - anasayfa/koleksiyon karuselleri: 297px slayt, 12px aralik, peek
   - urun galerisi: ekranla olceklenen slayt (390px'te 332px), 8px aralik, peek
   - kartta en fazla 3 swatch + "+N renk"
   - urun sayfasinda kalp basligin yanina tasinir
   - "Hepsini Gor" baglantisi basligin altina
   - koleksiyonda "Kategorinin One Cikanlari" gizli, yapisan filtre sekmesi
   ============================================================ */
(function () {
  var MOBIL = function () { return window.innerWidth <= 767; };
  function swiperAyar(kok, genislik, aralik) {
    document.querySelectorAll(kok).forEach(function (el) {
      var sw = el.swiper || (el.querySelector('.swiper') && el.querySelector('.swiper').swiper);
      if (!sw || sw.zxAyarli) return;
      sw.zxAyarli = true;
      sw.params.slidesPerView = 'auto';
      sw.params.spaceBetween = aralik;
      sw.params.centeredSlides = false;
      if (sw.params.breakpoints) sw.params.breakpoints = {};
      sw.slides.forEach(function (s) { s.style.width = typeof genislik === 'number' ? genislik + 'px' : genislik; });
      sw.update();
    });
  }
  function karuseller() {
    if (!MOBIL()) return;
    swiperAyar('[id*="featured_collection"] .swiper, [id*="featured_tum"] .swiper', 297, 12);
    swiperAyar('.swiper-slider__product-page__radius swiper-slider.swiper', 'calc((100vw - 17px) / 1.125)', 8);
  }
  function artiRenk() {
    if (!MOBIL()) return;
    document.querySelectorAll('.product-card .product-form__container__color').forEach(function (kap) {
      if (kap.querySelector('.zx-arti-renk')) return;
      var n = kap.querySelectorAll('.product-form__item').length;
      if (n > 3) {
        var s = document.createElement('span');
        s.className = 'zx-arti-renk';
        s.textContent = '+' + (n - 3) + ' renk';
        kap.appendChild(s);
      }
    });
  }
  function kalpTasi() {
    if (!MOBIL()) return;
    var baslik = document.querySelector('.product__title');
    var kalp = document.querySelector('.product-form__buttons__content__media wishlist-button.btn--wishlist-productpage');
    if (baslik && kalp && !baslik.contains(kalp)) baslik.appendChild(kalp);
  }
  function hepsiniGor() {
    if (!MOBIL()) return;
    document.querySelectorAll('[id*="featured_collection"], [id*="featured_tum"]').forEach(function (sec) {
      if (sec.querySelector('.zx-hepsini-gor')) return;
      var btn = sec.querySelector('.secondary-btn__container a, .section__button a, a.btn--border');
      var bas = sec.querySelector('.section-heading-container');
      if (!btn || !bas) return;
      var a = document.createElement('a');
      a.className = 'zx-hepsini-gor';
      a.href = btn.getAttribute('href');
      a.textContent = 'Hepsini Gör';
      bas.insertAdjacentElement('afterend', a);
    });
  }
  function koleksiyon() {
    if (!MOBIL() || !document.body.classList.contains('template-collection')) return;
    /* "Kategorinin One Cikanlari" bolumu gizli */
    document.querySelectorAll('h2.section-heading-text').forEach(function (h) {
      if (/Kategorinin Öne Çıkanları/i.test(h.textContent)) { var s = h.closest('.shopify-section'); if (s) s.style.display = 'none'; }
    });
    /* filtre metni */
    var oz = document.querySelector('.facets-toolbar summary');
    if (oz && !oz.querySelector('.zx-filtre-metin')) {
      oz.querySelectorAll('span').forEach(function (sp) { if (/filtrele/i.test(sp.textContent)) { sp.textContent = ''; sp.classList.add('zx-filtre-metin'); } });
    }
    /* yapisan filtre sekmesi (dossha: sol kenarda 40x48 beyaz, huni ikonu) */
    if (!document.querySelector('.zx-yuzen-filtre') && oz) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'zx-yuzen-filtre'; b.setAttribute('aria-label', 'Filtreler');
      b.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="#111" stroke-width="1.4"><path d="M1 3h14M4 8h8M6.5 13h3"/></svg>';
      b.addEventListener('click', function () { oz.click(); });
      document.body.appendChild(b);
      var bar = document.querySelector('.facets-toolbar');
      var goster = function () { var r = bar.getBoundingClientRect(); b.classList.toggle('gorunur', r.bottom < 0); };
      window.addEventListener('scroll', goster, { passive: true }); goster();
    }
  }
  /* favori butonu sepete ekle yaninda kalir (kalpTasi kapatildi) */
  function hepsi() { karuseller(); artiRenk(); hepsiniGor(); koleksiyon(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  setTimeout(hepsi, 800); setTimeout(hepsi, 2000); setTimeout(hepsi, 4000);
  var g = new MutationObserver(function () { artiRenk(); });
  g.observe(document.body, { childList: true, subtree: true });
})();


/* TUR 55 ek: sablon sinifi + filtre etiketi + bulten yer tutucusu */
(function () {
  function sablon() {
    var h = document.documentElement, b = document.body.className;
    h.classList.remove('zx-urun', 'zx-koleksiyon', 'zx-anasayfa');
    if (/zx-tpl-product/.test(b)) h.classList.add('zx-urun');
    else if (/zx-tpl-collection/.test(b)) h.classList.add('zx-koleksiyon');
    else if (/zx-tpl-index/.test(b)) h.classList.add('zx-anasayfa');
  }
  function filtreMetni() {
    if (window.innerWidth > 767) return;
    var b = document.querySelector('.facets-toolbar .mobile-facets__button');
    if (!b) return;
    b.childNodes.forEach(function (n) { if (n.nodeType === 3 && /filtrele/i.test(n.textContent)) n.textContent = ' Filtreler'; });
    b.querySelectorAll('span').forEach(function (s) { if (/filtrele/i.test(s.textContent)) s.textContent = 'Filtreler'; });
  }
  function bulten() {
    var i = document.querySelector('footer .newsletter-form input[type=email]');
    if (i) i.setAttribute('placeholder', 'E-mail Adresinizi giriniz');
  }
  function hepsi() { sablon(); filtreMetni(); bulten(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', hepsi); else hepsi();
  setTimeout(hepsi, 1000);
})();

/* koleksiyon gorunum ikonlari: mobilde yalnizca ilk iki gorunur (dossha) */
(function () {
  function ikon() {
    if (window.innerWidth > 767) return;
    var g = [...document.querySelectorAll('.facets-toolbar .grid-selector .collection-grid__item')].filter(function (e) { return e.offsetParent !== null; });
    g.slice(2).forEach(function (e) { e.style.display = 'none'; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ikon); else ikon();
  setTimeout(ikon, 1000); setTimeout(ikon, 2500);
})();

/* footer alt bar (mobil): "© 2026 ZYNEX. Tum Haklari Saklidir" tek satir */
(function () {
  function telif() {
    if (window.innerWidth > 767) return;
    var alt = document.querySelector('footer .footer__content-bottom');
    if (!alt || alt.querySelector('.zx-telif-satir')) return;
    var yil = alt.querySelector('.copyright__content');
    var hak = [...alt.querySelectorAll('p, span, div')].find(function (e) { return e.children.length <= 1 && /Tüm Hakları Saklıdır/i.test(e.textContent) && !/Dijital/.test(e.textContent); });
    if (!yil || !hak) return;
    var satir = document.createElement('p');
    satir.className = 'zx-telif-satir';
    satir.textContent = yil.textContent.trim() + ' ' + hak.textContent.trim().replace(/\.?$/, '.');
    hak.classList.add('zx-telif-gizli'); yil.classList.add('zx-telif-gizli');
    (hak.parentElement || alt).insertBefore(satir, hak);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', telif); else telif();
  setTimeout(telif, 1200);
})();

/* ============================================================
   Urun galerisi buyutme (lightbox): kapatma yollari
   Tema yalnizca sag ustteki X dugmesine kapatma bagliyor; bos alana
   tiklama ve ESC yok. Ustelik X, header'in altinda kaldigi icin
   tiklanamiyordu (z-index duzeltmesi zynex-custom.css'te).
   Burada: bos alana tiklayinca ve ESC ile de kapanir.
   ============================================================ */
(function () {
  var DOKUNULMAZ = '.theme-lightbox__image, .theme-lightbox__toggle, .swiper-button-next,' +
                   ' .swiper-button-prev, .swiper-pagination, a, button, video, iframe, model-viewer';
  var bas = null;

  function acikKutu() { return document.querySelector('theme-lightbox.active'); }

  function kapat(kutu) {
    if (!kutu) return;
    if (typeof kutu.close === 'function') { kutu.close(); return; }
    kutu.classList.remove('animate');
    setTimeout(function () { kutu.classList.remove('active'); }, 500);
    document.body.classList.remove('overflow-hidden');
    document.body.style.paddingRight = '';
  }

  /* kaydirma hareketini tiklama sanmamak icin baslangic noktasini tut */
  document.addEventListener('pointerdown', function (e) {
    bas = { x: e.clientX, y: e.clientY };
  }, true);

  document.addEventListener('click', function (e) {
    var kutu = acikKutu();
    if (!kutu || !kutu.contains(e.target)) return;
    if (e.target.closest && e.target.closest(DOKUNULMAZ)) return;
    if (bas && (Math.abs(e.clientX - bas.x) > 10 || Math.abs(e.clientY - bas.y) > 10)) return;
    kapat(kutu);
  }, false);

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.keyCode !== 27) return;
    var kutu = acikKutu();
    if (kutu) kapat(kutu);
  }, false);
})();
